<div *ngIf="!isError" class="floating-container">
    <mat-spinner class="floating-spinner"></mat-spinner>
    <div  class="small-margin">
        <p class="floating-text">{{floatingString}}</p>
    </div>
    <div class="small-logo-holder">
        <img src="/assets/img/snacktimelogo.png" class="small-logo">
    </div>
</div>
<div *ngIf="isError" class="floating-container">
    <mat-card>
        <mat-card-header>
            <mat-card-title>{{errortitle}}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <p>{{errormessage}}</p>
          </mat-card-content>
          <mat-card-actions>
            <button mat-raised-button color="accent" class="fill-parent-width" (click)="tryAgain()">{{errorbutton}}</button>
          </mat-card-actions>
    </mat-card>
</div>